const doc = [({"da":({"js":({"admin":({"activity_participants":({"index":({"all_participants":"Alle deltagere"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;